import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { TopNav } from "../components/layout/TopNav";
import { BookList } from "./dashboard/BookList";
import { UploadPanel } from "./dashboard/UploadPanel";

/**
 * The service's front door, per docs/mockup/Upload.dc.html: the upload panel
 * on the left, the Books on the right. The nav carries no Book title and no
 * steps here, because no Book is open.
 */
export function Dashboard() {
  const { t } = useTranslation("common");
  return (
    <AppShell nav={<TopNav />}>
      <div className="grid min-w-0 flex-1 grid-cols-1 items-start gap-6 lg:grid-cols-2">
        <h1 className="sr-only">{t("books")}</h1>
        <UploadPanel />
        <BookList />
      </div>
    </AppShell>
  );
}
